import React from "react";
import { motion } from "framer-motion";

// Apple-Watch-style circular progress ring with a gold glow.
export default function PerformanceRing({
  percentage = 0,
  size = 120,
  stroke = 10,
  color = "#D4AF37",
  track = "rgba(255,255,255,0.10)",
  label,
  value,
  valueClass = "",
  testid,
}) {
  const pct = Math.max(0, Math.min(100, percentage));
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c - (pct / 100) * c;
  const filterId = `ring-glow-${testid || Math.round(size)}`;

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }} data-testid={testid}>
      <svg width={size} height={size} className="-rotate-90">
        <defs>
          <filter id={filterId} x="-50%" y="-50%" width="200%" height="200%">
            <feDropShadow dx="0" dy="0" stdDeviation="2.5" floodColor={color} floodOpacity="1" />
            <feDropShadow dx="0" dy="0" stdDeviation="7" floodColor={color} floodOpacity="0.55" />
            <feDropShadow dx="0" dy="0" stdDeviation="14" floodColor={color} floodOpacity="0.25" />
          </filter>
        </defs>
        <circle cx={size / 2} cy={size / 2} r={r} fill="transparent" stroke={track} strokeWidth={stroke} />
        <motion.circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="transparent"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={c}
          initial={{ strokeDashoffset: c }}
          animate={{ strokeDashoffset: offset }}
          transition={{ duration: 1.1, ease: "easeOut" }}
          style={{ filter: `url(#${filterId})` }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
        {value !== undefined ? (
          <span className={`font-cover leading-none ${valueClass || "text-3xl"}`}>{value}</span>
        ) : (
          <span className="font-cover text-3xl leading-none" style={{ color, textShadow: `0 0 8px ${color}cc, 0 0 20px ${color}66` }}>{Math.round(pct)}%</span>
        )}
        {label && <span className="font-mono text-[9px] uppercase tracking-[0.2em] text-white/50 mt-1">{label}</span>}
      </div>
    </div>
  );
}
